module.exports = __webpack_public_path__ + "static/media/homepage.7593b365.svg";